var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionOsmandProLogoColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_osmand_pro_logo_colored"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M8 1.75L16 3.75L20 2.75V17.75L16 18.75L8 16.75V22H4V2.75L8 1.75Z",
    fill: "#5714CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 568 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.87311L8 5.87311V12.6269L16 14.6269V7.87311Z",
    fill: "#FFC30D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "light",
    d: "M16 3.75L20 2.75V17.75L16 18.75V3.75Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionOsmandProLogoColored);
export default __webpack_public_path__ + "static/media/ic_action_osmand_pro_logo_colored.46a115518c238e6597611b2e79c5ffc9.svg";
export { ForwardRef as ReactComponent };